
// src/connects/images-view.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import lifecycle from '../helpers/lifecycle'
import { inject } from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import { translate } from 'react-i18next'
import { emitAlertMessage } from '../actions/alert-message'
import actions from '../actions'
import each from 'lodash/each'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import { isSmartPhone } from '../helpers/agent-type'

export const mapStateToProps = (state)=> {
  return {
    files: state.imagesView.items,
    isFetchFailed: state.imagesView.isFetchFailed,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var imagesViewFiles = []
  var _files = []
  _files = filter(stateProps.files, (file)=> file.content_type.match(/^image|video|audio/))

  stateProps.files && each(_files, (file)=> {
    imagesViewFiles.push({
      imagesViewFiles_id: file.file_id && file.file_id || file.video_id,
      file: file,
    })
  })

  return {
    ...stateProps, ...dispatchProps, ...ownProps,
    imagesViewFiles: imagesViewFiles,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willUpdate:(props, nextProps)=> {
      if (props.imagesViewFiles.length == 0 && nextProps.imagesViewFiles.length > 0 && nextProps.ui.mode == 'CHAT_ROOM') {
        var index = 0
        if (!nextProps.ui.isVideo) {
          index = findIndex(nextProps.imagesViewFiles, (file)=> file.imagesViewFiles_id == nextProps.ui.selected_file.file_id && file.file.content_type.match(/^image/))
        }
        else {
          index = findIndex(nextProps.imagesViewFiles, (file)=> file.imagesViewFiles_id == nextProps.ui.selected_file.video_id && file.file.content_type.match(/^video|audio/))
        }

        if (index < 0) {
          nextProps.updateUI({ mode: 'OUT_OF_LIST', index: undefined })
        }
        else {
          nextProps.updateUI({ active: true, index: index })
        }
      }

      if (props.ui.mode != nextProps.ui.mode && nextProps.ui.mode == 'OUT_OF_LIST') {
        nextProps.updateUI({ active: true })
      }
      //ui.modoがGROUP_TIMELINE・GROUP_COMMENTだった場合は下記の処理を通る
      if (props.imagesViewFiles.length == 0 && nextProps.imagesViewFiles.length > 0 && (nextProps.ui.mode == 'GROUP_TIMELINE' || nextProps.ui.mode == 'GROUP_COMMENT')) {
        var index = 0
        if (!nextProps.ui.isVideo) {
          index = findIndex(nextProps.imagesViewFiles, (file)=> file.imagesViewFiles_id == nextProps.ui.selected_file.file_id && file.file.content_type.match(/^image/))
        }
        else {
          index = findIndex(nextProps.imagesViewFiles, (file)=> file.imagesViewFiles_id == nextProps.ui.selected_file.video_id && file.file.content_type.match(/^video|audio/))
        }

        if (nextProps.imagesViewFiles.length == 1 || index < 0) {
          nextProps.updateUI({ mode: 'OUT_OF_LIST', index: undefined })
        }
        else {
          nextProps.updateUI({ active: true, index: index })
        }
      }
    },

    photoSaved: ()=> dispatch(emitAlertMessage("label:フォトライブラリに保存しました")),
    savePhotoFailed: ()=> dispatch(emitAlertMessage("error:フォトライブラリに保存できませんでした")),

    willUnmount: ()=> dispatch(actions.clearImagesView()),

    closeImagesView: (props)=> {
      dispatch(actions.clearImagesView())
      props.updateUI({ active: false, selected_file: undefined, mode: undefined })
    },

    showImagesView: (mode, parent_id, selected_file, props)=>{
      switch(mode) {
        case 'CHAT_ROOM':
          dispatch(actions.fetchChatImagesView(parent_id))
          break
        case 'GROUP_TIMELINE':
          isSmartPhone ?
          dispatch(actions.fetchGroupTimelineImagesView(parent_id, true)):
          dispatch(actions.fetchGroupTimelineImagesView(parent_id, false))
          break
        case 'GROUP_COMMENT':
          dispatch(actions.fetchGroupTimelineCommentImagesView(parent_id))
          break
        case 'OUT_OF_LIST':
          break
      }
      props.updateUI({ mode, selected_file, isVideo: !!selected_file.content_type.match(/^video|audio/)})
    },
      // mode: 'CHAT_ROOM', 'GROUP_TIMELINE','GROUP_COMMENT', 'OUT_OF_LIST'
      // parent_id: chat_room_id / group_id
      // selected_file: image
      // props: will be injected by 'inject'
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state: {
      active: false,
      mode: undefined,
      selected_file: undefined,
      isVideo: false,
      index: 0,
    }
  }),
  lifecycle,
  translate(),
  inject({ showImagesView: PropTypes.func }),
)
 



// WEBPACK FOOTER //
// ./src/connects/images-view.js